import { ORDER_FULFILLMENT_STATUS_CONSTANTS } from '@/utils/constants';

export const OrderMixin = {
    methods: {
        $_getBadgeStatusColor(status) {
            const statuses = [...ORDER_FULFILLMENT_STATUS_CONSTANTS];

            const result = statuses.find((s) => s.name === status);

            if (result) 
                return result.color;

            return 'pending';
        }
    }
};
